const CarrouselTabsServices = (instance) => {

    const getCarrouselTabs = () => instance.get('carrousels');

    return {
        getCarrouselTabs,
    };
};
export default CarrouselTabsServices;
